/** Error codes the hub assistant API returns; shared by the server router and the client store. */
export const assistantErrorCodes = [
  "BAD_REQUEST",
  "RATE_LIMITED",
  "MODEL_UNAVAILABLE",
  "TIMEOUT",
  "NO_HUB_PROFILE",
  "UNAVAILABLE",
] as const;
export type AssistantErrorCode = (typeof assistantErrorCodes)[number];
